export const actionKey = '@@messages';

//# sourceMappingURL=constants.js.map